import React from 'react';
import { useSellerData, getCategoriesText, type SellerPageFederatedSeller } from '@fiverr-private/seller_pages_toolbox';

const selectSeller = (seller: SellerPageFederatedSeller) => seller;

export const MetaDescription = () => {
    const seller = useSellerData(selectSeller) as SellerPageFederatedSeller | undefined;

    if (!seller) {
        return null;
    }

    const displayName = seller.user.profile.displayName || seller.user.name;

    const certs = (seller.certifications || []).map((c) => c.certificationName).filter(Boolean);

    const educations = (seller.activeEducations || [])
        .map((e) => [e.degreeTitle, e.school, e.toYear].filter(Boolean).join(', '))
        .filter(Boolean);

    const parts: string[] = [];

    let intro = `Hire ${displayName} on Fiverr.`;
    if (seller.isPro) {
        const vettedFor = (getCategoriesText(seller.proSubCategories || []).filter(Boolean) as string[]).join(', ');
        if (vettedFor) {
            intro = `Hire ${displayName} on Fiverr, selected by the Fiverr Pro team for expertise in ${vettedFor}.`;
        }
    }
    parts.push(intro);

    if (certs.length) {
        parts.push(`Certifications: ${certs.join(', ')}.`);
    }

    if (educations.length) {
        parts.push(`Education: ${educations.join('; ')}.`);
    }

    return <meta name="description" content={parts.join(' ')} />;
};
